
const validateRegisteration =  (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = 'Email is required';
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
    ) {
      errors.email = 'Invalid email address';
    }
    if(!values.fullName){
      errors.fullName = "Required"
    }
    else if(values.fullName.length < 4){
      errors.fullName = "Name must be more than four characters"
    }
    else if(!/^\w+(\s\w+)+$/.test(values.fullName.trim())){
      errors.fullName = "Full name must be two words or more"
    }
    if(!values.country){
        errors.country = "Select a country"
    }
    if(!values.phoneNo){
        errors.phoneNo = "Required"
    }
    else if(!/^[0-9]{9,12}$/.test(values.phoneNo)){
        errors.phoneNo = "Invalid Phone No";
    }
    if(!values.password){
        errors.password = "Required";
    }
    else if(!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{9,}$/.test(values.password)){
        errors.password ="Password must contain a letter and a number, and be minimum of 9 characters"
    }
    if(!/\d{6}/.test(values.code)){
        errors.code = "Required"
    }
    if(!/\d{4}/.test(values.pin)){
        errors.pin = "Required"
    }
    return errors;
  }

export default validateRegisteration; 